// src/components/resources/tools/generators/shared/trackGeneratorBridge.ts

import { sendEvent } from '~/lib/gtag'

/** Where a generator growth CTA was shown. */
export type GeneratorBridgePlacement =
  | 'post_export'
  | 'companion'
  | 'in_tool_variant'
  | 'page_upsell'
  | 'export_hint'

/** Destination class for funnel reporting. */
export type GeneratorBridgeTarget =
  | 'request_access'
  | 'variant_page'
  | 'companion_tool'
  | 'analyzer'
  | 'calculator'
  // Editorial guide content (blog posts, /resources/guides/*) — distinct from
  // `companion_tool` so guide clicks don't pollute the tool cross-sell funnel
  // split (r3542875315).
  | 'guide'

/**
 * Records a click from a generator growth surface (post-export prompt,
 * companion callout, or in-tool variant link).
 *
 * @param {Object} options - Bridge click context.
 * @param {string} options.resourceSlug - Generator slug the user exported from.
 * @param {GeneratorBridgePlacement} options.placement - UI surface.
 * @param {GeneratorBridgeTarget} options.targetType - Destination category.
 * @param {string} options.destinationPath - Path navigated to.
 * @param {number} [options.engagementMs] - Time on tool before click.
 */
export function trackGeneratorBridgeClick(options: {
  resourceSlug: string
  placement: GeneratorBridgePlacement
  targetType: GeneratorBridgeTarget
  destinationPath: string
  engagementMs?: number
}): void {
  const { resourceSlug, placement, targetType, destinationPath, engagementMs } = options

  sendEvent({
    action: 'button_click',
    label: `${placement}:${targetType}`,
    engagement_time_msec: engagementMs,
    params: {
      placement,
      surface_path: typeof window !== 'undefined' ? window.location.pathname : '',
      resource_slug: resourceSlug,
      destination_path: destinationPath,
      bridge_target: targetType,
      interaction_type: 'link_click',
    },
  })
}
